export const getStatusColor = (status) => {
  switch (status) {
    case "completed":
      return "success";
    case "processing":
      return "warning";
    case "pending":
      return "pending";
    case "cancelled":
      return "error";
    case "failed":
      return "error";
    default:
      return "pending";
  }
};

export const getStatusText = (status, currentTranslations) => {
  const statusTranslate = currentTranslations?.Status;
  switch (status) {
    case "completed":
      return statusTranslate?.completed;
    case "processing":
      return statusTranslate?.processing;
    case "pending":
      return statusTranslate?.pending;
    case "cancelled":
      return statusTranslate?.cancelled;
    case "failed":
      return statusTranslate?.failed;
    default:
      return statusTranslate?.pending;
  }
};

export const getPaymentStatusText = (status, currentTranslations) => {
  const paymentTranslate = currentTranslations?.PaymentStatus;
  switch (status) {
    case "paid":
      return paymentTranslate?.paid;
    case "pending":
      return paymentTranslate?.pending;
    case "failed":
      return paymentTranslate?.failed;
    default:
      return paymentTranslate?.pending;
  }
};

export const getPaymentMethodText = (method, currentTranslations) => {
  const methodPaymentTranslate = currentTranslations?.PaymentMethod;
  switch (method) {
    case "cod":
      return methodPaymentTranslate?.cod;
    case "vnpay":
      return methodPaymentTranslate?.vnpay;
    case "momo":
      return methodPaymentTranslate?.momo;
    default:
      return methodPaymentTranslate?.unknown;
  }
};
